module.exports = __webpack_public_path__ + "static/media/android-chrome-512x512.5c1bcd8b.png";